module.exports = __webpack_public_path__ + "static/img/loading.1d7e79cf.png";